// ============================================================
// HOUSE OF CARDS — saveManager v1
// localStorage only (Pier/Firebase integration is Phase 7).
// Hardcore rule: death WIPES the save. Non-hardcore: deaths counted,
// progress kept, respawn in the Hall.
// ============================================================

const KEY = "hoc_save_v1";
const CHECKPOINT_KEY = "hoc_checkpoint_v1";

export function newGameState() {
  return {
    version: 1,
    screen: "menu",           // menu | title | story | manor | dead
    scriptId: null,           // active story block
    currentRoom: "hall",
    cursed: false,            // Tenant timer active
    hardcore: false,          // death wipes save
    sawManorIntro: false,
    inventory: [],
    flags: {},                // bookshelf_solved, music_box_opened, took_ball, egg_*, ...
    drives: {},               // mercy/cruelty/greed/curiosity/surrender/defiance — see endingsEngine
    completedEndings: {},     // { endingId: true } — which endings reached (for canon + a future discovery screen)
    canonDone: false,         // true once the canon true ending (This Was Never Your House) is reached
    canonViaRecreation: false,// true if canon was reached by recreating a prior ending under the curse (Path A)
    lastEndingId: null,       // transient: which ending just resolved (recorded on the `end` beat)
    unlockedDoors: [],
    trophies: [],             // {id, name, desc}
    deaths: 0,
    settings: { motion: true, ambient: true, muted: false },
  };
}

export function loadGame() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (s.version !== 1) return null;
    return s;
  } catch {
    return null;
  }
}

export function saveGame(state) {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    /* storage full / private mode — play on, just unsaved */
  }
}

// ── CHECKPOINT SAVES ────────────────────────────────────────────
// A checkpoint is a snapshot taken after each psychosis reset
// (collectible secured / major task). On hardcore death, the game
// reverts to this snapshot instead of wiping everything — you lose
// progress since the last checkpoint, not all progress. If no
// checkpoint exists (died before your first collectible), THEN
// it wipes fully as before.
export function saveCheckpoint(state) {
  try {
    // Snapshot the state as it stands right after the collectible was
    // secured, positioned in the Hall (safe respawn point).
    const snap = {
      ...state,
      screen: "manor",
      currentRoom: "hall",
      _checkpoint: true,
    };
    localStorage.setItem(CHECKPOINT_KEY, JSON.stringify(snap));
  } catch {
    /* best effort */
  }
}

export function loadCheckpoint() {
  try {
    const raw = localStorage.getItem(CHECKPOINT_KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (s.version !== 1) return null;
    return s;
  } catch {
    return null;
  }
}

export function wipeCheckpoint() {
  try {
    localStorage.removeItem(CHECKPOINT_KEY);
  } catch {
    /* nothing to do */
  }
}

export function wipeSave() {
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem(CHECKPOINT_KEY);
  } catch {
    /* nothing to do */
  }
}
